import { Navigate, Outlet, useLocation } from "react-router-dom";
import useIntegratorAuth from "../../hooks/useIntegratorAuth";

export default function RequireIntegratorAuth() {
  const { authenticated, loading } = useIntegratorAuth();
  const location = useLocation();

  if (loading) return null;

  return authenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/integrador/login" state={{ from: location }} replace />
  );
}